export default "__VITE_ASSET__ec94f22a__"